module.exports = __webpack_public_path__ + "img/register-image.e18e42d8.png";